import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initState = () => ({
  error: null,
  isLoading: false,
  isHandling: false,
  settings: {
    surcharge: {
      parameters: null,
      visibility: null,
    },
    theme: null,
  },
  areValidSettings: false,
});

export default {
  namespaced: true,
  state: initState(),
  getters,
  mutations,
  actions,
};
